import { render, staticRenderFns } from "./CategoryTree.vue?vue&type=template&id=4c463213&scoped=true"
import script from "./CategoryTree.vue?vue&type=script&lang=ts"
export * from "./CategoryTree.vue?vue&type=script&lang=ts"
import style0 from "./CategoryTree.vue?vue&type=style&index=0&id=4c463213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c463213",
  null
  
)

export default component.exports